import type { BlockDef } from '../../prop-types.ts'
import { EMPTY_TEXT } from '../../text.ts'

/** Short benefits in a row. The block a model should reach for instead of writing three paragraphs,
 *  which is why `whenNotToUse` on `text` points here. */
export const features: BlockDef = {
  type: 'features',
  v: 1,
  label: { en: 'Features', ar: 'المزايا' },
  scope: 'page',
  description:
    'Three to six short points, each a small icon, a title and a sentence. The standard "why choose us" row.',
  whenToUse: 'Benefits, services offered, steps in a process, what is included — anything that is a short list of short things.',
  whenNotToUse: 'For one long explanation — that is a Text section. For prices — a Features row with prices in the body reads as a price list nobody can compare.',
  variants: [
    { value: 'row', label: { en: 'In a row', ar: 'في صف' } },
    { value: 'cards', label: { en: 'As cards', ar: 'كبطاقات' } },
    { value: 'numbered', label: { en: 'Numbered steps', ar: 'خطوات مرقّمة' } },
  ],
  fields: [
    { key: 'heading', label: { en: 'Heading', ar: 'العنوان' }, type: { kind: 'text' }, default: EMPTY_TEXT },
    {
      key: 'items',
      label: { en: 'Points', ar: 'النقاط' },
      type: {
        kind: 'list',
        min: 2,
        max: 6,
        item: [
          {
            key: 'icon',
            label: { en: 'Icon', ar: 'الأيقونة' },
            // ⚠️ A CLOSED SET, NOT A FILE UPLOAD AND NOT AN EMOJI STRING. An icon that arrives as an
            // uploaded SVG is an injection surface on the published page; an emoji renders as a
            // different picture on every phone and has no accessible name. A named icon is drawn by
            // the renderer, in the template's own colours, and carries the item's title as its label.
            type: {
              kind: 'enum',
              options: [
                { value: 'star', label: { en: 'Star', ar: 'نجمة' } },
                { value: 'check', label: { en: 'Tick', ar: 'صح' } },
                { value: 'clock', label: { en: 'Clock', ar: 'ساعة' } },
                { value: 'shield', label: { en: 'Shield', ar: 'درع' } },
                { value: 'truck', label: { en: 'Delivery', ar: 'توصيل' } },
                { value: 'heart', label: { en: 'Heart', ar: 'قلب' } },
                { value: 'spark', label: { en: 'Spark', ar: 'وميض' } },
                { value: 'none', label: { en: 'No icon', ar: 'بدون أيقونة' } },
              ],
            },
            default: 'star',
          },
          { key: 'title', label: { en: 'Title', ar: 'العنوان' }, type: { kind: 'text' }, default: EMPTY_TEXT },
          { key: 'body', label: { en: 'One sentence', ar: 'جملة واحدة' }, type: { kind: 'text' }, default: EMPTY_TEXT },
        ],
      },
      default: [],
      requiredForPublish: true,
    },
  ],
}
